define(["require", "exports", "./helpers/errorReporting", "./helpers/getCatchError", "./helpers/metrics"], function (require, exports, errorReporting_1, getCatchError_1, metrics_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.metrics = exports.getCatchError = exports.errorReporting = void 0;
    Object.defineProperty(exports, "errorReporting", { enumerable: true, get: function () { return errorReporting_1.errorReporting; } });
    Object.defineProperty(exports, "getCatchError", { enumerable: true, get: function () { return getCatchError_1.getCatchError; } });
    Object.defineProperty(exports, "metrics", { enumerable: true, get: function () { return metrics_1.metrics; } });
});
//# sourceMappingURL=index.js.map